import wrongSlide_bg from'../images/wrongSlide_bg.gif'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import classroomMainCut_bg_presentation4 from'../images/classroomMainCut_bg_presentation4.png'
import classroomMainCut_bg_presentation6 from'../images/classroomMainCut_bg_presentation6.png'
import ryderTakingOffJumper from'../images/ryderTakingOffJumper.png'
import ryderBendingOver4 from'../images/ryderBendingOver4.gif'
import ryderCloserLook from'../images/ryderCloserLook.png'
import stacyShowingPussy from'../images/stacyShowingPussy.png'
import stacyGettingNaked from'../images/stacyGettingNaked.png'
import stacyOnTableArousedBG from'../images/stacyOnTableArousedBG.png'
import stacyClitorisQuestion from'../images/stacyClitorisQuestion.gif'
import stacyClitorisQuestionBG from'../images/stacyClitorisQuestionBG.png'
import stacyTouchingTits from'../images/stacyTouchingTits.gif'
import stacyButtPetting from'../images/stacyButtPetting.gif'
import stacyAfterOrgasm from'../images/stacyAfterOrgasm.png'
import wipingDeskBG from'../images/wipingDeskBG.gif'
import stacyTeachMasturbation2 from'../images/stacyTeachMasturbation2.gif'
import ryderInsta from'../images/ryderInsta.png'
import masturbationGameGIF from'../images/masturbationGameGIF.gif'
import phoebeStuckTree from'../images/phoebeStuckTree.gif'
import phoebeBurger from'../images/phoebeBurger.png'
import phoebeUpsideDown from'../images/phoebeUpsideDown.gif'
import phoebeCunnilingus from'../images/phoebeCunnilingus.png'
import phoebeCunnilingus8 from'../images/phoebeCunnilingus8.png'
import phoebeCunnilingus14 from'../images/phoebeCunnilingus14.png'
import phoebeCunnilingus28 from'../images/phoebeCunnilingus28.png'
import phoebeCumming from'../images/phoebeCumming.gif'

const gallery = [
  [0, "Chapter 1", 0],
  [classroomMainCut_bg_presentation1, "0", 1],
  [classroomMainCut_bg_presentation2, "0", 2],
  [wrongSlide_bg, "0", 3],
  [ryderTakingOffJumper, "0", 4],
  [ryderBendingOver4, "0", 5],
  [classroomMainCut_bg_presentation4, "0", 6],
  [ryderCloserLook, "0", 7],
  [classroomMainCut_bg_presentation6, "0", 8],
  [stacyShowingPussy, "0", 9],
  [0, "Chapter 2", 10],
  [stacyGettingNaked, "0", 11],
  [stacyOnTableArousedBG, "0", 12],
  [stacyClitorisQuestion, "0", 13, stacyClitorisQuestionBG],
  [stacyTouchingTits, "0", 14],
  [stacyButtPetting, "0", 15],
  [stacyTeachMasturbation2, "0", 16],
  [masturbationGameGIF, "0", 17],
  [stacyAfterOrgasm, "0", 18],
  [wipingDeskBG, "0", 19],
  [ryderInsta, "0", 20],
  [0, "Chapter 3", 21],
  [phoebeStuckTree, "0", 22],
  [phoebeBurger, "0", 23],
  [phoebeUpsideDown, "0", 24],
  [phoebeCunnilingus, "0", 25],
  [phoebeCunnilingus8, "0", 26],
  [phoebeCunnilingus14, "0", 27],
  [phoebeCunnilingus28, "0", 28],
  [phoebeCumming, "0", 29]

];

export default gallery;
